<template>
  <div class="boxForm">
    <el-form ref="form"
             :model="form"
             :rules="formRules"
             label-width="60px">
      <span style="line-height:40px;font-size:1.2rem;padding-left:20px;padding-bottom:20px;">临涣焦化公司投诉信息反馈</span>
      <el-form-item label="主题"
                    prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="内容"
                    prop="content">
        <el-input type="textarea"
                  :rows="10"
                  :maxlength="1000"
                  v-model="form.content"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
                   :loading="loading"
                   @click="onSubmit">保存</el-button>
        <el-button :disabled="loading"
                   @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
import {addComplaintsRecord} from '@/api/login';
export default {
  data () {
    return {
      form: {
        title: '',
        content: ''
      },
      loading: false,
      formRules: {
        title: [{required: true, message: '请输入主题', trigger: 'blur'}],
        content: [{required: true, message: '请输入内容', trigger: 'blur'}]
      }
    };
  },
  methods: {
    onSubmit () {
      this.$refs.form.validate( ( validate ) => {
        if ( validate ) {
          this.loading = true;
          const params = {title: this.form.title, content: this.form.content};

          addComplaintsRecord( params ).then( () => {
            this.loading = false;
            this.$message.success( '新增成功' );
            this.$refs.form.resetFields();
          } )
            .catch( () => {
              this.loading = false;
            } );
        }
      } );
    },
    cancel () {
      this.$refs.form.resetFields();
    }
  }
};
</script>

<style scoped>
.boxForm {
  padding: 8% 10% 0 10%;
  box-sizing: border-box;
}
</style>